import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../../../../constants/selectLists/platformList'
import {
  LINE_ITEM_DV360_EDIT,
  LINE_ITEM_FACEBOOK_EDIT,
  LINE_ITEM_GOOGLE_EDIT,
  LINE_ITEM_TIKTOK_EDIT
} from '../../../../constants/forms'

export const getLineItemEditFormName = platform => {
  if (platform === FACEBOOK_PLATFORM) {
    return LINE_ITEM_FACEBOOK_EDIT
  } else if (platform === GOOGLE_PLATFORM) {
    return LINE_ITEM_GOOGLE_EDIT
  } else if (platform === TIKTOK_PLATFORM) {
    return LINE_ITEM_TIKTOK_EDIT
  } else if (DV_360_PLATFORM) {
    return LINE_ITEM_DV360_EDIT
  }
}
